import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, addDoc, updateDoc } from "firebase/firestore";
import escribirLog from "./escribirLog";
let uid;

async function añadirDocumento(infoDocumento, autor, baseDatos, titleLog) {

  const db = getFirestore(firebaseApp);
  const firestoreRef = await addDoc(collection(db, baseDatos), infoDocumento);

  //agregar el identificador
  await updateDoc(firestoreRef, {
    id: firestoreRef.id
  });

    uid = firestoreRef.id
    //verificar si se genero el identificador de firebase de 20 caracteres
    if (uid.length === 20) {
      escribirLog(titleLog, infoDocumento, autor);
    } else {
      uid = null
    }

    return uid
}

export default añadirDocumento;
